import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import Suppliers from "./pages/Suppliers";
import Purchasing from "./pages/Purchasing";
import Customers from "./pages/Customers";
import Sales from "./pages/Sales";
import Quotations from "./pages/Quotations";
import Invoices from "./pages/Invoices";
import Finance from "./pages/Finance";
import OperationalExpense from "./pages/OperationalExpense";
import Personalia from "./pages/Personalia";
import Reports from "./pages/Reports";
import EFaktur from "./pages/EFaktur";
import UserManagement from "./pages/UserManagement";
import Settings from "./pages/Settings";
import { Toaster } from "./components/ui/sonner";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/inventory" element={<ProtectedRoute module="inventory"><Inventory /></ProtectedRoute>} />
            <Route path="/suppliers" element={<ProtectedRoute module="suppliers"><Suppliers /></ProtectedRoute>} />
            <Route path="/purchasing" element={<ProtectedRoute module="purchasing"><Purchasing /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute module="customers"><Customers /></ProtectedRoute>} />
            <Route path="/sales" element={<ProtectedRoute module="sales"><Sales /></ProtectedRoute>} />
            <Route path="/quotations" element={<ProtectedRoute module="quotations"><Quotations /></ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute module="invoices"><Invoices /></ProtectedRoute>} />
            <Route path="/finance" element={<ProtectedRoute module="finance"><Finance /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute module="expenses"><OperationalExpense /></ProtectedRoute>} />
            <Route path="/personalia" element={<ProtectedRoute module="personalia"><Personalia /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute module="reports"><Reports /></ProtectedRoute>} />
            <Route path="/efaktur" element={<ProtectedRoute module="efaktur"><EFaktur /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute module="users"><UserManagement /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute module="settings"><Settings /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
